import styled from 'styled-components';

export const MainWrapperLogin = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top:${props.theme.spacing.large.l20};
    `
);

export const DividerWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        position: relative;
        margin: ${props.theme.spacing.large.l50} ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l60};
        height: 1px;
        background-color: ${props.theme.colors.grey.base1};
`);

export const OrWrapper = styled.div(
    props => `
        width: 3.6rem;
        height: 3.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props.theme.colors.grey.light1};
        border: 1px solid ${props.theme.colors.grey.base1};
        border-radius: ${props.theme.misc.borderRadius.round};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.light5};
        font-weight: ${props.theme.font.fontWeight.bold};
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -1.8rem;
        z-index:${props.theme.misc.zIndex.xxlarge};
`);

export const LoginOtpWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const LoginOtpText = styled.a(
    props => `
        font-size:${props.theme.font.large.font16};
        font-weight: ${props.theme.font.fontWeight.bold};
        color: ${props.theme.colors.blue.base};
        cursor: pointer;
`);

export const ResendBlock = styled.div(
    props => `
        width:40%;
        display: flex;
        align-items: center;
        justify-content: center;

        @media only screen and (min-width:320px) and (max-width: 767px){
            padding-top: ${props.theme.sapcing.nospacing};
            justify-content: flex-end;
        }
    `,
)

export const ResendText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `,
)

export const ForgotPasswordBlock = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: ${props.theme.spacing.large.l11};
        padding-right: ${props.theme.spacing.small.s4};
  
        @media only screen and (min-width:320px) and (max-width: 768px){
            padding-top: 0rem;
            justify-content: flex-end;
        }
  
        @media only screen and (min-width:1025px) and (max-width: 1300px){
            justify-content: flex-end;
        }
    `,
  );

export const ForgotPasswordLoaderContainer = styled.div(
    props => `
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        width: 86%;
        margin-top: 5px;
    `
)
  
  export const ForgotPasswordBlockText = styled.a(
      props => `
          font-size: ${props.theme.font.large.font14};
          color: ${props.theme.colors.blue.base};
          font-weight: ${props.theme.font.fontWeight.bold};
          cursor: pointer;
      `,
  )